import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";

import { UserGuideModalContainer } from "../HelpCenter.styles";
import { Button } from "components/Button";
import { SubHeading } from "style/components/SubHeading.styles";

export const UserGuideModal = ({
  show,
  onHide,
  url,
  title,
  walkthroughSteps,
}) => {
  const dispatch = useDispatch();

  const handleClickStart = (event) => {
    event.preventDefault();

    if (walkthroughSteps.navigate) {
      walkthroughSteps.navigate();
    }

    if (walkthroughSteps.steps) {
      dispatch();
      // setRunWalkthrough({
      //   run: true,
      //   steps: walkthroughSteps.steps,
      // })
      onHide();
    } else {
      dispatch(
        toast({
          type: "error",
          body: "Walkthrough not found",
        })
      );
    }
  };

  return (
    <UserGuideModalContainer show={show} onHide={onHide}>
      <SubHeading>{title}</SubHeading>
      <p>{`Let's watch a 2 minute video to get started.`}</p>
      <iframe
        src={url}
        allowFullScreen
        title="video"
        allow="autoplay; encrypted-media"
      />
      <div className="my-4">Or</div>
      <Button
        size="small"
        label="Start User Guide"
        className="start-user-guide"
        onClick={handleClickStart}
      />
    </UserGuideModalContainer>
  );
};

UserGuideModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  url: PropTypes.string,
  title: PropTypes.string,
  walkthroughSteps: PropTypes.object,
};
